export default "__VITE_ASSET__CRuGc5X3__"